<template>
    <main id="main-content"
        class="container mx-auto"
        tabindex="-1">
        <slot></slot>
    </main>
</template>
